import http from "./httpService";
import { getConfig } from "../config/config.js";

const config = getConfig();
const serviceEndpoint = config.apiEndpoint + "/jugadores";

export async function getJugador(recordId) {
  try {
    const response = await http.get(serviceEndpoint + "/" + recordId);
    return response.data.record;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function getJugadores() {
  try {
    const response = await http.get(serviceEndpoint);
    return response.data.records;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}

export async function saveJugador(data, parentId) {
  if (data._id) return await http.put(serviceEndpoint + "/" + data._id, data);
  else {
    if (parentId) data.parentId = parentId;
    const response = await http.post(serviceEndpoint, data);
    return response;
  }
}

// Guarda solo la camiseta. La lista de fe del torneo no tiene una camiseta propia:
// la edita en el padrón, así que el cambio impacta en todos los torneos.
export async function saveCamisetaJugador(recordId, camiseta) {
  return await http.put(serviceEndpoint + "/" + recordId + "/camiseta", { camiseta });
}

export async function deleteJugador(recordId) {
  return await http.delete(serviceEndpoint + "/" + recordId);
}

export async function importJugadores(file) {
  const formData = new FormData();
  formData.append("files", file); // 'files' matches the field name expected by the backend
  try {
    const response = await http.post(serviceEndpoint + "/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return false;
    else return false;
  }
}

export async function getJugadoresSelect() {
  let items = [];
  try {
    const response = await http.get(serviceEndpoint);
    response.data.records.map((item) => {
      items.push({
        value: item._id,
        label: item.apellido + ", " + item.nombre,
        equipo: item.equipo,
        camiseta: item.camiseta,
        isExcepcion: !!item.isExcepcion,
      });
    });
    return items;
  } catch (error) {
    if (error.message.toUpperCase().includes("NETWORK ERROR")) return error.message.toUpperCase();
    else return [];
  }
}
